import { Api } from "./api";
import config from "../utils/config";

class AgentActivityService extends Api {
    getActivity(activityId: string) {
        return this.http.get(config.api.endpoints.activity.get(activityId), { withCredentials: true });
    }

    initAgentActivity(data: {
        supplier_name: string;
        supplier_email: string;
    }) {
        return this.http.post(config.api.endpoints.activity.init, data, { withCredentials: true });
    }

    sendEmail(data: {
        activity_id: string;
        supplier_email: string;
        supplier_name: string;
        subject: string;
        body_html: string;
    }) {
        return this.http.post(config.api.endpoints.activity.sendEmail, data, { withCredentials: true });
    }

    requestQuote(data: {
        activity_id: string;
        supplier_email: string;
        supplier_name: string;
        ingredient: string;
        quantity: number;
        unit: string;
    }) {
        return this.http.post(config.api.endpoints.activity.requestQuote, data, { withCredentials: true });
    }

    inviteSupplier(data: {
        activity_id: string;
        hubspot_id: string;
        supplier_email: string;
        supplier_name: string;
    }) {
        return this.http.post(config.api.endpoints.activity.inviteSupplier, data, { withCredentials: true });
    }
}

export default new AgentActivityService();
